import {configureStore} from '@reduxjs/toolkit';
import {useDispatch, useSelector, useStore} from 'react-redux';
import {reducer as user} from '~/common/fabric/User/reducers/user';
import {reducer as loginModal} from '~library/organisms/LoginModal/reducer';
import {reducer as guests} from '~/common/fabric/EventGuests/reducers/guests/index';
import {ecardApi} from '~/QuickEcards/api/ecard';
import {eGiftApi} from '~/QuickEcards/api/egift';
import {ecardReducer} from '~/QuickEcards/store/reducers/ecard';
import {recipientMessagesReducer} from '~/QuickEcards/store/reducers/recipientMessages';
import {reducer as review} from '~/common/fabric/reducers/review/index';
import {promiseResolverMiddleware} from '~/common/middleware/promiseResolver';
import {assetsReducer} from '~/QuickEcards/store/reducers/assets';
import {guestsApi} from '~/common/fabric/EventGuests/api/endpoints/guests';
import {api as cartApi} from '~/CreateFabricInvitation/api/api';
import {guestsLegacyActionMapper} from '~/common/fabric/EventGuests/reducers/guests/legacy-reducer';
import {reducer as eGiftCard} from '~/common/fabric/GiftCard/reducers/eGiftCard';
import {reducer as giftCardData} from '~/ViewFabricGreetingCard/reducers/giftCardData/reducer';
import {reducer as guest} from '~/ViewFabricGreetingCard/reducers/guest/reducer';

const reducers = {
  user,
  loginModal,
  review,
  guest,
  guests,
  eGiftCard,
  giftCardData,
  recipientMessages: recipientMessagesReducer,
  ecard: ecardReducer,
  assets: assetsReducer,
  [guestsApi.reducerPath]: guestsApi.reducer,
  [cartApi.reducerPath]: cartApi.reducer,
  [ecardApi.reducerPath]: ecardApi.reducer,
  [eGiftApi.reducerPath]: eGiftApi.reducer,
};

export const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(
      ecardApi.middleware,
      eGiftApi.middleware,
      guestsApi.middleware,
      cartApi.middleware,
      promiseResolverMiddleware,
      guestsLegacyActionMapper
    ),
});

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<AppStore>();
